/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ domain: NonNullable<unknown> }} Palette_Search_FailedInputs */

const en_palette_search_failed = /** @type {(inputs: Palette_Search_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not search ${i?.domain}: open the search page`)
};

/**
* | output |
* | --- |
* | "Could not search {domain}: open the search page" |
*
* @param {Palette_Search_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const palette_search_failed = /** @type {((inputs: Palette_Search_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Palette_Search_FailedInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_palette_search_failed(inputs)
});